module.exports = __webpack_public_path__ + "img/biaoqian_danganguan.98d86c51.png";